<template>
  <div>
    <v-autocomplete
      :value="garage"
      :items="filterGarages"
      :label="$i18n.t('Garage Select')"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              <div>{{ data.item.name }}</div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";
import { commonMixin } from "@/mixins/common";
import corpService from "@/store/common/module/CorpService";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "GarageSelect",
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class GarageSelect extends (Vue, Themeable) {
  garage = null;
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.garage = null;
    this.$emit("input", null);
  }

  get filterGarages() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const garages = corpService.garages;
    if (filterby == "") return garages;
    const fc = garages.filter(function (c) {
      return c.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.garage = newVal;
      this.$emit("input", newVal._id);
    } else {
      this.$emit("input", null);
    }
    if (!newVal) this.$emit("input", null);
  }

  async setDefault() {
    await corpService.populateGarages();
    const garages = corpService.garages;
    this.garages = garages;

    if (this.value && this.garages) {
      for (let i = 0; i < this.garages.length; i++) {
        if (this.garages[i]._id === this.value) {
          this.garage = this.garages[i];
          break;
        }
      }
    }
  }

  async mounted() {
    // await corpService.populateGarages();
    await this.setDefault();
    this.loading = false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "" || this.value == null) {
      this.garages = null;
    }
    // await corpService.populateGarages();
    // this.garages = corpService.garages;
    await this.setDefault();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
